import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "9471eedd-f05f-4cb5-9995-31f4016bf3cc",
  publicId: "28",
  name: "Transmission lines and analogies",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01],
};

export default lesson;
